import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import tw from "twin.macro"

const StyledContainer = styled.div`
  ${tw`pt-6 md:grid md:grid-cols-3 md:items-center`}
  & {
    h1 {
      ${tw`text-3xl font-semibold text-neutralLight md:col-span-1`}
    }
    p {
      ${tw`md:col-span-2`}
    }
  }
`

const CustomHeading = ({ title, subTitle }) => (
  <StyledContainer className="custom-heading">
    <h1>{title}</h1>
    <p>{subTitle}</p>
  </StyledContainer>
)

CustomHeading.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
}

CustomHeading.defaultProps = {
  subTitle: "",
}

export default CustomHeading
